// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feis-logo{
  width:136px;
  cursor: pointer;
}
.navbar-expand-sm .offcanvas {
  justify-content: center;
}
.green{
  color:#68AD3F !important;
}
.grey-32{
  color:#323232 !important;
}
.searchDiv {
  margin-right: 7px;
  margin-top: 12px;
}
.search,
.search:focus {
  border-width: 0px;
  border-radius: 5px;
  outline: 0;
  -webkit-appearance: none;
  box-shadow: none;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
}

::placeholder {
  color: #797979;
}
.web-btn {
  min-width: 134px !important;
}

.MuiTabs-flexContainer {
  justify-content: space-between;
}

.gridImage {
  padding: 0 !important;
}

.gridImage {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.home-page-tab .MuiTabs-indicator {
  height: 3px;
}
#mui-p-41355-T-1 .MuiTabs-indicator {
  background-color: #000000 !important;
}
#mui-p-43674-T-2 {
}
.gridImage1 {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.MuiTabs-root {
  flex-grow: 1;
}

.MuiButtonBase-root-MuiButton-root:hover {
  -webkit-text-decoration: none;
  text-decoration: none;
  background-color: initial;
  border: 2px solid #68ad3f;
}
.MuiButtonBase-root-MuiButton-root {
  line-height: normal !important;
  padding: 10px !important;
}
.advantages-card p {
  padding-top: 10px;
}

.font-20 {
  padding: 50px 0px 50px 0px;
  font-size: 20px;
  color: #68ad3f;
  text-align: center;
}

.border-btm {
  border-bottom: 1px solid rgb(241, 241, 241);
  z-index: -1;
  position: absolute;
  width: 100%;
  left: 0px;
}

.bg-1 {
  background-color: #f4ffee;
  height: 300px;
  width: 100%;
  z-index: -1;
  position: absolute;
  left: 0px;
  transform: skewY(-2deg);
  margin: 40px 0px 40px 0px;
}

.bg-2 {
  background-color: #fffaf2;
  height: 300px;
  width: 100%;
  z-index: -2;
  position: absolute;
  left: 0px;
  transform: skewY(2deg);
  margin: 40px 0px 40px 0px;
}

.dashboard-Org {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #68ad3f;
  height: 289px;
  margin: 80px 0px 80px 0px;
}

.registration {
  height: 393px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  line-height: 12px !important;
}

.searchbutton {
  border: none;
  background: white;
  margin-left: -40px !important;
  justify-content: center;
}

.desktop-heading {
  display: block;
  font-weight: 700;
  color: #88d35b;
}

.heading-color {
  color: #fbb040;
}

.mobile-heading {
  display: none;
}

.border-line {
  border-bottom: 1px solid rgb(241, 241, 241);
  margin-top: 20px;
  z-index: -1;
  position: absolute;
  width: 100%;
  left: 0px;
}

.border-line-2 {
  border-bottom: 1px solid rgb(241, 241, 241);
  margin-top: 5px;
  z-index: -1;
  position: absolute;
  width: 100%;
  left: 0px;
}

.text-center {
  text-align: center;
}

.open-events {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 50px;
}

.advantages {
  text-align: center;
  line-height: 31.5px;
  padding: 50px 0px 50px 0px;
}

.advantages-list {
  display: flex;
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;
  padding: 62px;
}

.adv-title {
  color: #424242;
  font-size: 24px;
  line-height: 28.44px;
  font-weight: 500;
}

.search {
  width: "219px";
  padding: 10px 10.51px 10px 10px;
  margin-right: -4px;
  outline: none;
}

.getPaidIcon {
  width: 60px;
  height: 60px;
  background: #ececec;
  border-radius: 50px;
}

.WhyFeis h2 {
  font-family: "Rubik";
  font-weight: 500;
  font-size: 24px;
  color: black;
  margin: 120px 0 40px 0;
}

.WhyFeis {
}

.adv-desc {
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #424242;
  opacity: 0.7;
}

.experience {
  display: flex;
  align-items: center;
  padding: 50px 0px 50px 0px;
}

/* .kids-img {
  height: 100%;
  width: 500px;
} */

.exp-details {
  margin-top: 20px;
  font-size: 21px;
  line-height: 32px;
  text-align: left;
  color: rgba(0, 0, 0, 0.702469);
}

.dashboard-organizer img {
  width: 180.95px;
  height: 62px;
}

.dashboard-organizer {
  height: 318px;
  position: relative;
  font-family: "Rubik";
  color: #68ad3f;
  column-gap: 10px;
}

.dashboard-organizer h3 {
  font-weight: 700;
  font-size: 52px !important;
}

.bg-3 {
  background-color: #f4ffee;
  width: 100%;
  z-index: -2;
  position: absolute;
  left: 0px;
  transform: skewY(2deg);
  height: 318px;
}

.background-slant {
  height: 300px;
  width: 100%;
  z-index: -1;
  position: absolute;
  left: 0px;
  background-color: #f4ffee;
  transform: skewY(1deg);
  margin: 40px 0px 40px 0px;
}

.event-links {
  height: 819px;
  display: flex;
  align-items: center;
}

.event-links-title {
  text-transform: uppercase;
}

.event-section-mobile {
  display: none;
}

.event-section {
  display: block;
  z-index: -1;
  position: absolute;
  right: 0px;
  width:40%;
}

.events-image {
  width: 100%;
}

.links-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 60px 0px 40px 0px;
}

.EventsList {
  display: flex;
  flex-wrap: wrap;
  column-gap: 30px;
  /* margin : 0px 20px; */
}

.EventsList1 {
  display: flex;
  column-gap: 30px;
}

.links-card {
  display: flex;
  align-items: center;
  border: 1px solid #eaeaea;
  border-radius: 10px;
  height: 80px;
  width: 273px;
  margin: 20px;
  padding: 10px;
}

.link-name {
  margin: 0px 0px 0px 10px;
}

.orgaizerImg {
  display: flex;
  width: 77vw !important;
  height: auto !important;

  top: 0px;
}

.orgainzer-Content {
  width: 796px;
  font-family: "Rubik";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  margin-top: 50px;

  text-align: center;

  color: #797979;
}

.orgainzer-Content span,
a {
  color: #68ad3f !important;
  text-decoration: none !important;
}

@media only screen and (min-width: 0px) and (max-width: 320px) {
  .EventsList button {
    font-size: 12px;
    padding: 2px;
    width: auto;
  }
}

/*  <---------------------------- media query for mpbile devices ------------------------------------->  */
@media only screen and (min-width: 0px) and (max-width: 767px) {
  .EventsList-pd .MuiTabs-flexContainer .MuiTabs-flexContainer {
    column-gap: 20px;
  }
  .dashboard-organizer {
    height: 210px;
  }
  .mob-btn {
    margin-top: -3rem !important;
    margin-top: -3rem !important;
  }
  .event-links {
    margin-bottom: -3rem !important;
    margin-top: -3rem !important;
  }
  .cardSection .MuiTabPanel-root{
    padding: 8px 24px;;
  }
  .css-ke65ae-MuiTabs-indicator {
    position: absolute;
    height: 2px;
    bottom: 8px !important;
    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    background-color: #68ad3f;
  }
  .orgainzer-Content {
    width: 796px;
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    margin-top: 5px;
    text-align: center;
    color: #797979;
  }
  .home-page-tab .MuiTabs-flexContainer .MuiButtonBase-root {
    flex-grow: 1;
    display: "flex";
    margin-bottom: -9px;
    min-width: 10px !important;
    padding: 12px 0px !;
    font-size: 12px;
    min-height: 56px !important;
  }
  .home-page-tab .MuiTabs-flexContainer {
    display: -ms-flexbox;
    padding-inline: 20px;
    display: flex;
    padding-inline: 20px;
  }
  .desktop-content {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 23px !important;
    line-height: 0px;
    text-align: center;
    text-transform: uppercase;
    color: #424242;
  }

  .WhyFeis h2 {
    margin: 40px 0 40px 0;
  }

  .dashboard-organizer h3 {
    font-size: 17px !important;
  }

  .dashboard-organizer img {
    width: 81.95px;
    height: 62px;
  }

  .font-20 {
    padding: 20px 0px 50px 0px;
  }

  .advantages-list {
    padding: 0px;
  }

  .search,
  .search:focus {
    width: 76.3vw;
    height: 35px;

    border-width: 0px;
    outline: 0;
    -webkit-appearance: none;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }

  .searchbutton {
    margin-top: 15px;
  }

  .EventsList {
    margin: 0px 20px;
  }

  .EventsList1 {
    flex-wrap: wrap;
  }

  .login-btn {
    font-size: 10px !important;
    width: 100% !important;
    height: auto !important;
  }

  #regBtn {
    cursor: pointer;
    font-size: 0.875rem !important;
    color: white !important;
  }

  .EventsList button {
    font-size: 12px;
    padding: 2px;
    width: auto;
  }


  .border-btm {
    display: none;
  }

  .mobile-heading {
    font-weight: 700;
    display: block;
    color: #68ad3f;
  }

  .desktop-heading {
    display: none;
  }

  .registration {
    height: 300px;
  }

  .open-events {
    height: 100%;
    margin-bottom: 20px;
  }

  .bg-1 {
    height: 200px;
  }

  .bg-2 {
    height: 200px;
  }

  .bg-3 {
    height: 200px;
  }

  .bg .register-events {
    padding: 20px 0px 20px 0px;
    align-items: flex-start;
    flex-direction: column;
    height: 100%;
  }

  .event-name {
    font-size: 14px;
  }
  .reg-datee {
    font-size: 11px;
  }

  .border-line {
    display: none;
  }

  .web-btn {
    display: none !important;
  }

  .advantages {
    padding: 30px 20px 30px 20px;
  }

  .advantages-list {
    display: flex;
    flex-direction: column;
  }

  .advantages-card {
    padding: 10px 20px 10px 20px;
  }

  .exp-section {
    text-align: center;
    padding: 10px 0px 20px 0px;
  }

  .exp-details {
    text-align: center;
    padding: 20px 0px 0px 0px;
  }

  .experience {
    flex-direction: column-reverse;
    padding: 60px 20px 60px 20px;
  }

  /* .kids-img {
    width: 100%;
    padding: 20px 0px 0px 0px;
  } */

  .event-section-mobile {
    display: block;
  }

  .background-slant {
    height: 250px;
  }

  .organizer {
    height: 200px;
  }

  .event-section {
    display: none;
  }

  .create-event {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 500;
    font-size: 40px;
    line-height: 120%;
    text-transform: uppercase;
    color: #000000;
    flex: none;
    order: 0;
    flex-grow: 0;
  }

  .event-links {
    height: 100%;
    flex-direction: column;
    padding: 80px 0px 30px 0px;
  }

  .events-image-mobile {
    width: 100%;
    padding: 20px 0px 20px 0px;
  }

  .why-feis {
    height: 100%;
  }

  .border-line-2 {
    display: none;
  }

  .mobile-btn {
    background-color: #68ad3f;
    color: white;
  }

  .links-card {
    justify-content: flex-start;
    padding: 15px;
  }

  .link-name {
    margin-left: 10px;
  }

  .link {
    margin-top: 4px;
  }
}

.MuiButtonBase-root-MuiButton-root {
  flex: none;
}

.organizer-content {
  font-family: "Rubik";
  font-style: normal;
  font-weight: 700;
  font-size: 52px;
  line-height: 120%;
  text-align: center;
  text-transform: uppercase;
  color: #68ad3f;
  flex: none;
  order: 1;
  flex-grow: 0;
}

@media only screen and (min-width: 481px) and (max-width: 600px) {
  .heading-color {
    font-size: 30px !important;
  }

  .mobile-heading {
    font-size: 30px !important;
  }

  .desktop-content {
    font-size: 25px !important;
  }
}
@media screen and (max-width: 800px) {
  .header.navbar-expand-sm .offcanvas {
    position: relative;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .offcanvas-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
    display: none !important;
  }
}
/* / <---------------------------- media query for ipad devices -------------------------------------> / */
@media only screen and (min-width: 760px) and (max-width: 980px) {
  /* .kids-img {
    width: 300px;
  } */
  .OrgImage {
    padding: 2rem;
  }

  .advantages-list {
    padding: 0px;
    margin-top: 80px;
  }
  .dashboard-organizer h3 {
    font-weight: 700;
    font-size: 33px !important;
  }
  .dashboard-organizer img {
    width: 120px;
  }
  .devincornell {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .event-section {
    width: 50%;
  }

  .event-links {
    height: 556px;
  }

  .event-links h2 {
    font-size: 30px !important;
  }

  .dashboard-organizer {
    align-items: center;
  }
  .desktop-content {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 40px !important;
    line-height: 0px;
    text-align: center;
    text-transform: uppercase;
    color: #424242;
  }

  #EventsList2 button {
    font-size: 15px !important;
  }

  .gridImagerow {
    margin-top: 50px;
  }

  .EventsList {
    margin-top: -76px;
  }
  .home-page-tab .MuiTabs-flexContainer .MuiButtonBase-root {
    min-height: 55px !important;
    flex-grow: 1;
    display: flex;
    margin-bottom: -8px;
    min-width: 10px !important;
    padding: 12px 0px !;
    font-size: 12px;
  }
}

/*  <---------------------------- media query for ipad pro devices ------------------------------------->  */
@media only screen and (min-width: 981px) and (max-width: 1210px) {
  /* .kids-img {
    width: 400px;
  } */
  .OrgImage {
    padding: 2rem;
    margin-top: "110px";
  }
  .dashboard-organizer {
    align-items: center;
  }
  .event-links {
    margin-left: 0vw !important;
  }

  [type="button"]:not(:disabled), [type="reset"]:not(:disabled), [type="submit"]:not(:disabled), button:not(:disabled) {
    cursor: pointer;
  }
  .desktop-content {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 40px !important;
    line-height: 0px;
    text-align: center;
    text-transform: uppercase;
    color: #424242;
  }
}
@media screen and (min-width: 1200px) {
  .eventListw {
    width: 65vw;
  }
  .MuiTabs-indicator {
    position: absolute;
    height: 2px;
    width: 100%;
    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    background-color: #68ad3f;
  }
}

@media only screen and (min-width: 1200px) and (max-width: 1900px) {
  .OrgImage {
    padding: 3rem;
    margin-top: "110px";
  }
  .EventsList2 {
    padding: 0px 0px 4rem 0px !important;
  }

  .orgainzer-Content {
    width: auto;
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    margin-top: -17px;
    text-align: center;
    color: #797979;
    margin-bottom: 36px;
  }
  .desktop-content {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 40px !important;
    text-align: center;
    text-transform: uppercase;
    color: #424242;
  }
  .dashboard-organizer {
    align-items: center;
    margin-bottom: 6rem;
  }
}

@media only screen and (min-width: 1900px) and (max-width: 1930px) {
  .devincornell {
    padding: 50px 0px 0px 0px !important;
  }

  .dashboard-organizer {
    align-items: center;
    margin-bottom: 6rem;
  }
  .EventsList2 {
    padding: 0px 0px 4rem 0px !important;
  }
  .OrgImage {
    padding: 4.5rem;
  }
  .desktop-content {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 40px !important;
    text-align: center;
    text-transform: uppercase;
    color: #424242;
  }

  .organizer {
    margin-bottom: 6rem;
  }
  .title-signup {
    height: 65px;
    width: 165px;
  }
  .title-signup :hover {
    border: 2px solid #68ad3f;
  }
  .create-event-btn {
    padding: 13px !important;
    border: 3px solid #68ad3f !important;
  }
  .MuiTypography-root {
    margin: 0 !important;
    font-family: Rubik !important;
    font-weight: 400 !important;
    font-size: 1rem !important;
    line-height: 1.5 !important;
    margin-bottom: 0.35em !important;
    margin-bottom: 25px !important;
    max-width: 100% !important;
  }

  .orgainzer-Content {
    width: 100% !important;
    font-family: "Rubik" !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 20px !important;
    line-height: 150% !important;
    margin-top: 50px !important;
    text-align: center !important;
    color: #797979 !important;
  }

  .WhyFeis h2 {
    font-family: "Rubik" !important;
    font-weight: 500 !important;
    color: black !important;
  }

  .event-section {
    display: flex;
    z-index: -1;
    position: absolute;
    right: 0px;
  }

  .event-section {
    position: relative;
    display: none;
  }

  .event-section-mobile {
    display: contents;
  }

  .events-image-mobile {
    height: 67%;
    position: absolute;
    float: right;
    right: 0%;
  }

  .event-links {
    height: 563px;
    display: flex;
    align-items: center;
  }

  .adv-desc {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    color: #424242;
    opacity: 0.7;
  }

  .advantages-list {
    display: flex;
    justify-content: space-between;
    margin-left: auto;
    margin-right: auto;
    padding: 0px;
  }

  .css-112coge {
    max-width: 100% !important;
  }

  .adv-title {
    color: #424242 !important;
  }
  .search, .search:focus {
    border-width: 0px;
    border-radius: 5px;
    outline: 0;
    -webkit-appearance: none;
    box-shadow: none;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
  }

  .MuiTabs-flexContainer {
    justify-content: space-between;
  }

  .imageGridContainer {
    margin-bottom: 100px;
  }

  .endGrid {
    padding: 0 !important;
  }

  .gridImage {
    padding: 0 !important;
  }

  .gridImage {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }

  .gridImage1 {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

  .MuiTabs-root {
    flex-grow: 1;
  }

  .MuiButtonBase-root-MuiButton-root:hover {
    -webkit-text-decoration: none;
    text-decoration: none;
    background-color: initial;
    border: 2px solid #68ad3f;
  }
  .MuiButtonBase-root-MuiButton-root {
    line-height: normal !important;
    padding: 10px !important;
  }
  .advantages-card p {
    padding-top: 10px;
  }

  .font-20 {
    padding: 50px 0px 50px 0px;
    font-size: 20px;
    color: #68ad3f;
    text-align: center;
  }

  .border-btm {
    border-bottom: 1px solid rgb(241, 241, 241);
    z-index: -1;
    position: absolute;
    width: 100%;
    left: 0px;
  }

  .bg-1 {
    background-color: #f4ffee;
    height: 300px;
    width: 100%;
    z-index: -1;
    position: absolute;
    left: 0px;
    transform: skewY(-2deg);
    margin: 40px 0px 40px 0px;
  }

  .bg-2 {
    background-color: #fffaf2;
    height: 300px;
    width: 100%;
    z-index: -2;
    position: absolute;
    left: 0px;
    transform: skewY(2deg);
    margin: 40px 0px 40px 0px;
  }

  .dashboard-Org {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #68ad3f;
    height: 289px;
    margin: 80px 0px 80px 0px;
  }

  .registration {
    height: 380px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .searchbutton {
    border: none;
    background: white;
    margin-left: -40px !important;
    justify-content: center;
  }

  .desktop-content {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 40px;
    text-align: center;
    text-transform: uppercase;
  }

  .desktop-heading {
    display: block;
    font-weight: 700;
    color: #88d35b;
    font-size: 60px !important;
  }

  .heading-color {
    color: #fbb040;
  }

  .mobile-heading {
    display: none;
  }

  .border-line {
    border-bottom: 1px solid rgb(241, 241, 241);
    margin-top: 20px;
    z-index: -1;
    position: absolute;
    width: 100%;
    left: 0px;
  }

  .border-line-2 {
    border-bottom: 1px solid rgb(241, 241, 241);
    margin-top: 5px;
    z-index: -1;
    position: absolute;
    width: 100%;
    left: 0px;
  }

  .text-center {
    text-align: center;
  }

  .open-events {
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 50px;
  }

  .advantages {
    text-align: center;
    line-height: 31.5px;
    padding: 50px 0px 50px 0px;
  }

  .advantages-list {
    display: flex;
    justify-content: space-between;
    margin-left: auto;
    margin-right: auto;
    padding: 62px;
  }

  .adv-title {
    color: #424242;
    font-size: 24px;
    line-height: 28.44px;
    font-weight: 500;
  }

  .search {
    width: "219px";
    padding: 8px 10px;
    margin-right: -4px;
    outline: none;
  }

  .getPaidIcon {
    width: 60px;
    height: 60px;
    background: #ececec;
    border-radius: 50px;
  }

  .WhyFeis h2 {
    font-family: "Rubik";
    font-weight: 500;
    font-size: 24px;
    color: black;
    margin: 120px 0 40px 0;
  }

  .adv-desc {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: #424242;
    opacity: 0.7;
  }

  .experience {
    display: flex;
    align-items: center;
    padding: 50px 0px 50px 0px;
  }

  /* .kids-img {
    height: 100%;
    width: 500px;
  } */

  .exp-details {
    margin-top: 20px;
    font-size: 21px;
    line-height: 32px;
    text-align: left;
    color: rgba(0, 0, 0, 0.702469);
  }

  .dashboard-organizer img {
    width: 180.95px;
    height: 62px;
  }

  .dashboard-organizer {
    height: 318px;
    position: relative;
    font-family: "Rubik";
    color: #68ad3f;
    column-gap: 10px;
  }

  .dashboard-organizer h3 {
    font-weight: 700;
    font-size: 52px !important;
  }

  .bg-3 {
    background-color: #f4ffee;
    width: 100%;
    z-index: -2;
    position: absolute;
    left: 0px;
    transform: skewY(2deg);
    height: 318px;
  }

  .background-slant {
    height: 300px;
    width: 100%;
    z-index: -1;
    position: absolute;
    left: 0px;
    background-color: #f4ffee;
    transform: skewY(1deg);
    margin: 40px 0px 40px 0px;
  }

  .event-links {
    height: 819px;
    display: flex;
    align-items: center;
  }

  .event-links-title {
    text-transform: uppercase;
  }

  .event-section-mobile {
    display: none;
  }

  .event-section {
    display: block;
    z-index: -1;
    position: absolute;
    right: 0px;
  }

  .events-image {
    width: 100%;
  }

  .links-section {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 60px 0px 40px 0px;
  }

  .EventsList {
    display: flex;
    flex-wrap: wrap;
    column-gap: 30px;
    margin: 0px 20px;
  }
  .eventListw {
    width: 51vw;
  }

  .EventsList1 {
    display: flex;
    column-gap: 30px;
  }

  .links-card {
    display: flex;
    align-items: center;
    border: 1px solid #eaeaea;
    border-radius: 10px;
    height: 80px;
    width: 273px;
    margin: 20px;
    padding: 10px;
  }

  .link-name {
    margin: 0px 0px 0px 10px;
  }

  .orgaizerImg {
    display: flex;
    width: 77vw !important;
    height: auto !important;
    top: 0px;
  }

  .orgainzer-Content {
    width: 796px;
    font-family: "Rubik";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    margin-top: 50px;
    text-align: center;
    color: #797979;
  }

  .orgainzer-Content span,a {
    color: #68ad3f !important;
    text-decoration: none !important;
  }
  /* / <---------------------------- media query for mpbile devices -------------------------------------> / */
  @media only screen and (min-width: 0px) and (max-width: 900px) {
    .dashboard-organizer {
      height: 210px;
    }
    .home-page-tab {
      display: flex;
      flex-grow: 1;
      margin-bottom: 9px;
    }
    .desktop-content {
      font-family: "Rubik";
      font-style: normal;
      font-weight: 400;
      font-size: 25px !important;
      text-align: center;
      text-transform: uppercase;
      color: #424242;
    }

    .WhyFeis h2 {
      margin: 40px 0 40px 0;
    }

    .dashboard-organizer h3 {
      font-size: 17px !important;
      margin-top: 10px;
    }

    .dashboard-organizer img {
      width: 81.95px;
      height: 62px;
    }

    .font-20 {
      padding: 20px 0px 50px 0px;
    }

    .advantages-list {
      padding: 0px;
    }

    .search, .search:focus {
      width: 76.3vw;
      height: 35px;
      border-width: 0px;
      outline: 0;
      -webkit-appearance: none;
      box-shadow: none;
      -moz-box-shadow: none;
      -webkit-box-shadow: none;
    }

    .searchbutton {
      margin-top: 15px;
    }

    .EventsList {
      margin: 0px 20px;
    }

    .EventsList1 {
      flex-wrap: wrap;
    }

    [type="button"]:not(:disabled),
    [type="reset"]:not(:disabled),
    [type="submit"]:not(:disabled),
    button:not(:disabled) {
      font-size: 14px;
      width: auto;
      height: auto;
    }

    .login-btn {
      font-size: 10px !important;
      width: 100% !important;
      height: auto !important;
    }

    #regBtn {
      cursor: pointer;
      font-size: 14px !important;
      color: white !important;
    }

    .EventsList button {
      font-size: 16px;
      padding: 2px;
    }

    .border-btm {
      display: none;
    }

    .mobile-heading {
      font-weight: 700;
      display: block;
      color: #68ad3f;
    }

    .desktop-heading {
      display: none;
    }

    .registration {
      height: 300px;
    }

    .open-events {
      height: 100%;
      margin-bottom: 20px;
    }

    .bg-1 {
      height: 200px;
    }

    .bg-2 {
      height: 200px;
    }

    .bg-3 {
      height: 200px;
    }

    .bg .register-events {
      padding: 20px 0px 20px 0px;
      align-items: flex-start;
      flex-direction: column;
      height: 100%;
    }

    .event-name {
      font-size: 12px;
    }

    .border-line {
      display: none;
    }

    .web-btn {
      display: none !important;
    }

    .advantages {
      padding: 30px 20px 30px 20px;
    }

    .advantages-list {
      display: flex;
      flex-direction: column;
    }

    .advantages-card {
      padding: 10px 20px 10px 20px;
    }

    .exp-section {
      text-align: center;
      padding: 10px 0px 20px 0px;
    }

    .exp-details {
      text-align: center;
      padding: 20px 0px 0px 0px;
    }

    .experience {
      flex-direction: column-reverse;
      padding: 60px 20px 60px 20px;
    }

    /* .kids-img {
      width: 100%;
      padding: 20px 0px 0px 0px;
    } */

    .event-section-mobile {
      display: block;
    }

    .background-slant {
      height: 250px;
    }

    .organizer {
      height: 200px;
    }

    .event-section {
      display: none;
    }

    .create-event {
      font-family: "Rubik";
      font-style: normal;
      font-weight: 500;
      font-size: 40px;
      line-height: 120%;
      text-transform: uppercase;
      color: #000000;
      flex: none;
      order: 0;
      flex-grow: 0;
    }

    .event-links {
      height: 100%;
      flex-direction: column;
      padding: 80px 0px 30px 0px;
    }

    .events-image-mobile {
      width: 100%;
      padding: 20px 0px 20px 0px;
    }

    .why-feis {
      height: 100%;
    }

    .border-line-2 {
      display: none;
    }

    .mobile-btn {
      background-color: #68ad3f;
      color: white;
    }

    .links-card {
      justify-content: flex-start;
      padding: 15px;
    }

    .link-name {
      margin-left: 10px;
    }

    .link {
      margin-top: 4px;
    }
  }

  .MuiButtonBase-root-MuiButton-root {
    flex: none;
  }

  .organizer-content {
    font-family: "Rubik";
    font-style: normal;
    font-weight: 700;
    font-size: 52px;
    line-height: 120%;
    text-align: center;
    text-transform: uppercase;
    color: #68ad3f;
    flex: none;
    order: 1;
    flex-grow: 0;
  }

  @media only screen and (min-width: 481px) and (max-width: 600px) {
    .heading-color {
      font-size: 30px !important;
    }

    .mobile-heading {
      font-size: 30px !important;
    }

    .desktop-content {
      font-size: 25px !important;
    }
  }

 
  /* / <---------------------------- media query for ipad devices -------------------------------------> / */
  @media only screen and (min-width: 760px) and (max-width: 980px) {
    /* .kids-img {
      width: 300px;
    } */

    .advantages-list {
      padding: 0px;
      margin-top: 80px;
    }

    .event-section {
      width: 50%;
    }

    .event-links {
      height: 556px;
    }

    .event-links h2 {
      font-size: 30px !important;
    }
    .MuiTabs-indicator {
      position: absolute;
      height: 2px;
      bottom: 8px !important;
      width: 100%;
      transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      background-color: #68ad3f;
    }

    .dashboard-organizer {
      align-items: center;
    }

    [type="button"]:not(:disabled),
    [type="reset"]:not(:disabled),
    [type="submit"]:not(:disabled),
    button:not(:disabled) {
      cursor: pointer;
      font-size: 14px !important;
    }

    #EventsList2 button {
      font-size: 15px !important;
    }

    .gridImagerow {
      margin-top: 50px;
    }

    .EventsList {
      margin-top: 50px;
    }
  }

  /* / <---------------------------- media query for ipad pro devices -------------------------------------> / */
  @media only screen and (min-width: 981px) and (max-width: 1210px) {
    /* .kids-img {
      width: 400px;
    } */
    .OrgImage {
      padding: 2rem;
    }
    .dashboard-organizer {
      align-items: center;
    }

    .event-links {
      margin-left: 0vw !important;
    }

    [type="button"]:not(:disabled),
    [type="reset"]:not(:disabled),
    [type="submit"]:not(:disabled),
    button:not(:disabled) {
      cursor: pointer;
    }
  }

  @media only screen and (min-width: 1200px) and (max-width: 1800px) {
    .OrgImage {
      padding: 2rem;
    }
    .desktop-content {
      font-family: "Rubik";
      font-style: normal;
      font-weight: 400;
      font-size: 40px !important;
      text-align: center;
      text-transform: uppercase;
      color: #424242;
    }
  }

  @media only screen and (min-width: 1900px) and (max-width: 1930px) {
    .organizer {
      margin-bottom: 6rem;
    }

    .MuiTypography-root {
      margin: 0 !important;
      font-family: Rubik !important;
      font-weight: 400 !important;
      font-size: 1rem !important;
      line-height: 1.5 !important;
      margin-bottom: 0.35em !important;
      margin-bottom: 25px !important;
      max-width: 100% !important;
    }

    .orgainzer-Content {
      width: 90% !important;
      font-family: "Rubik" !important;
      font-style: normal !important;
      font-weight: 400 !important;
      font-size: 20px !important;
      line-height: 150% !important;
      margin-top: -48px !important;
      margin-bottom: 35px;
      text-align: center !important;
      color: #797979 !important;
    }

    .WhyFeis h2 {
      font-family: "Rubik" !important;
      font-weight: 500 !important;
      color: black !important;
      font-size: 40px;
      font-size: 40px !important;
      padding: 25px;
    }

    .event-section {
      display: flex;
      z-index: -1;
      position: absolute;
      right: 0px;
    }

    .event-section {
      position: relative;
      display: none;
    }

    .event-section-mobile {
      display: contents;
    }

    .events-image-mobile {
      height: 67%;
      position: absolute;
      float: right;
      right: 0%;
    }

    .event-links {
      height: 563px;
      display: flex;
      align-items: center;
    }

    .adv-desc {
      font-family: "Rubik";
      font-style: normal;
      font-weight: 400;
      font-size: 17px;
      color: #797979;
      opacity: 0.7;
    }

    .advantages-list {
      display: flex;
      justify-content: space-between;
      margin-left: auto;
      margin-right: auto;
      padding: 0px;
    }

    .css-112coge {
      max-width: 100% !important;
    }

    .adv-title {
      color: #424242 !important;
      font-size: 30px !important;
      line-height: 28.44px !important;
      font-weight: 500 !important;
    }
    #EventsList2 {
    }

    .EventsList1 {
      display: flex !important;
      column-gap: 30px !important;
    }
  }
}

.EventsList1 {
  display: flex !important;
  column-gap: 30px !important;
}

@media only screen and (min-width: 787px) and (max-width: 2000px) {
  .MuiTabPanel-root {
    padding: 0px 0 !important;
  }
}

@media screen and (min-width: 1200px) {
  .create-event Button {
    padding: 12px 32px 12px 32px !important;
    margin-top: 48px !important;
  }
}
@media screen and (min-width: 1800px) {
  .create-event Button {
    padding: 10px 24px 10px 24px !important;
    margin-top: 48px !important;
  }
  .desktop-content {
    font-size: 42px !important;
  }
}
@media screen and (max-width: 480px) {
  .offcanvas-body {
    flex-grow: 1;
    padding: 0px !important;
    overflow-y: auto;
  }
  .header.navbar-expand-sm .offcanvas {
    position: relative !important;
  }
  .navbar-expand-sm {
    padding: 0px 8px !important;
  }
}
@media screen and (max-width: 600px) {
  .title-signup {
    font-size: 16px !important;
  }
}

@media screen and (min-width: 1900px) {
  .desktop-content {
    font-size: 42px !important;
    margin-top: 38px !important;
  }
  .bg-1 {
    background-color: #f4ffee;
    height: 342px;
    width: 100%;
    z-index: -1;
    position: absolute;
    left: 0px;
    transform: skewY(-2deg);
    margin: 40px 0px 40px 0px;
  }
  .bg-2 {
    background-color: #fffaf2;
    height: 342px;
    width: 100%;
    z-index: -2;
    position: absolute;
    left: 0px;
    transform: skewY(2deg);
    margin: 40px 0px 40px 0px;
  }
  .cardSection {
    padding: 70px 0px 0px 0px !important;
  }
  .OrgImage {
    padding: 62px 0px 50px 0px;
  }
  .dashboard-organizer h3 {
    font-weight: 700;
    font-size: 60px !important;
  }
  .WhyFeis h2 {
    padding: 0px 0px 25px 0px;
}
}

@media screen and (max-width:700px) {
  .registration {
    height: 270px;
}
.create-event .MuiButtonBase-root{
font-size: 16px;
}
}
`, "",{"version":3,"sources":["webpack://./src/Feis-Homepage/Homepage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AASA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;AACA;AACA;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,2CAA2C;EAC3C,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;AACA;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;GAGG;;AAEH;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;EAEvB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;;EAEhB,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;AACF;;AAEA,0GAA0G;AAC1G;EACE;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,4BAA4B;IAC5B,4BAA4B;EAC9B;EACA;IACE,+BAA+B;IAC/B,4BAA4B;EAC9B;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IAEtB,sDAAsD;IACtD,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;IACf,2BAA2B;EAC7B;EACA;IAGE,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,aAAa;IACb,YAAY;;IAEZ,iBAAiB;IACjB,UAAU;IACV,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;;;EAGA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;;;KAGG;;EAEH;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,UAAU;IACV,QAAQ;IACR,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,wCAAwC;IACxC,oBAAoB;IACpB,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oEAAoE;IACpE,wBAAwB;EAC1B;AACF;AACA,0GAA0G;AAC1G;EACE;;KAEG;EACH;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;EACA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA,4GAA4G;AAC5G;EACE;;KAEG;EACH;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;EAChB;AACF;AACA;EACE;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IAEX,sDAAsD;IACtD,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,oCAAoC;EACtC;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oCAAoC;EACtC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,oCAAoC;EACtC;EACA;IACE,eAAe;EACjB;EACA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,wBAAwB;IACxB,oCAAoC;EACtC;EACA;IACE,oBAAoB;IACpB,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,gCAAgC;IAChC,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,+BAA+B;IAC/B,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;IAC7B,yBAAyB;EAC3B;;EAEA;IACE,+BAA+B;IAC/B,2BAA2B;IAC3B,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,aAAa;IACb,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;EAC3B;EACA;IACE,8BAA8B;IAC9B,wBAAwB;EAC1B;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,2CAA2C;IAC3C,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,6BAA6B;IAC7B,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,2CAA2C;IAC3C,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,0BAA0B;EAC5B;;EAEA;;;KAGG;;EAEH;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,gCAAgC;EAClC;EACA,4GAA4G;EAC5G;IACE;MACE,aAAa;IACf;IACA;MACE,aAAa;MACb,YAAY;MACZ,kBAAkB;IACpB;IACA;MACE,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,0BAA0B;MAC1B,kBAAkB;MAClB,yBAAyB;MACzB,cAAc;IAChB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,0BAA0B;MAC1B,gBAAgB;IAClB;;IAEA;MACE,cAAc;MACd,YAAY;IACd;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,aAAa;MACb,YAAY;MACZ,iBAAiB;MACjB,UAAU;MACV,wBAAwB;MACxB,gBAAgB;MAChB,qBAAqB;MACrB,wBAAwB;IAC1B;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;;IAEA;;;;MAIE,eAAe;MACf,WAAW;MACX,YAAY;IACd;;IAEA;MACE,0BAA0B;MAC1B,sBAAsB;MACtB,uBAAuB;IACzB;;IAEA;MACE,eAAe;MACf,0BAA0B;MAC1B,uBAAuB;IACzB;;IAEA;MACE,eAAe;MACf,YAAY;IACd;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,gBAAgB;MAChB,cAAc;MACd,cAAc;IAChB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,0BAA0B;MAC1B,uBAAuB;MACvB,sBAAsB;MACtB,YAAY;IACd;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,aAAa;MACb,sBAAsB;IACxB;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,kBAAkB;MAClB,0BAA0B;IAC5B;;IAEA;MACE,kBAAkB;MAClB,yBAAyB;IAC3B;;IAEA;MACE,8BAA8B;MAC9B,4BAA4B;IAC9B;;IAEA;;;OAGG;;IAEH;MACE,cAAc;IAChB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MACjB,yBAAyB;MACzB,cAAc;MACd,UAAU;MACV,QAAQ;MACR,YAAY;IACd;;IAEA;MACE,YAAY;MACZ,sBAAsB;MACtB,0BAA0B;IAC5B;;IAEA;MACE,WAAW;MACX,0BAA0B;IAC5B;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,yBAAyB;MACzB,YAAY;IACd;;IAEA;MACE,2BAA2B;MAC3B,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,UAAU;IACV,QAAQ;IACR,YAAY;EACd;;EAEA;IACE;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;EACF;;;EAGA,0GAA0G;EAC1G;IACE;;OAEG;;IAEH;MACE,YAAY;MACZ,gBAAgB;IAClB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,0BAA0B;IAC5B;IACA;MACE,kBAAkB;MAClB,WAAW;MACX,sBAAsB;MACtB,WAAW;MAEX,sDAAsD;MACtD,yBAAyB;IAC3B;;IAEA;MACE,mBAAmB;IACrB;;IAEA;;;;MAIE,eAAe;MACf,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;IAClB;EACF;;EAEA,8GAA8G;EAC9G;IACE;;OAEG;IACH;MACE,aAAa;IACf;IACA;MACE,mBAAmB;IACrB;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;;;;MAIE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,aAAa;IACf;IACA;MACE,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,0BAA0B;MAC1B,kBAAkB;MAClB,yBAAyB;MACzB,cAAc;IAChB;EACF;;EAEA;IACE;MACE,mBAAmB;IACrB;;IAEA;MACE,oBAAoB;MACpB,6BAA6B;MAC7B,2BAA2B;MAC3B,0BAA0B;MAC1B,2BAA2B;MAC3B,gCAAgC;MAChC,8BAA8B;MAC9B,0BAA0B;IAC5B;;IAEA;MACE,qBAAqB;MACrB,+BAA+B;MAC/B,6BAA6B;MAC7B,2BAA2B;MAC3B,0BAA0B;MAC1B,4BAA4B;MAC5B,4BAA4B;MAC5B,mBAAmB;MACnB,6BAA6B;MAC7B,yBAAyB;IAC3B;;IAEA;MACE,+BAA+B;MAC/B,2BAA2B;MAC3B,uBAAuB;MACvB,eAAe;MACf,0BAA0B;MAC1B,aAAa;IACf;;IAEA;MACE,aAAa;MACb,WAAW;MACX,kBAAkB;MAClB,UAAU;IACZ;;IAEA;MACE,kBAAkB;MAClB,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,kBAAkB;MAClB,YAAY;MACZ,SAAS;IACX;;IAEA;MACE,aAAa;MACb,aAAa;MACb,mBAAmB;IACrB;;IAEA;MACE,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,cAAc;MACd,YAAY;IACd;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,iBAAiB;MACjB,kBAAkB;MAClB,YAAY;IACd;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,yBAAyB;MACzB,0BAA0B;MAC1B,+BAA+B;MAC/B,2BAA2B;IAC7B;IACA;IACA;;IAEA;MACE,wBAAwB;MACxB,2BAA2B;IAC7B;EACF;AACF;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uCAAuC;IACvC,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,uCAAuC;IACvC,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;EAClB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,yBAAyB;EAC3B;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;EACA;IACE,yBAAyB;AAC7B;AACA;;AAEA;EACE;IACE,aAAa;AACjB;AACA;AACA,eAAe;AACf;AACA","sourcesContent":[".feis-logo{\n  width:136px;\n  cursor: pointer;\n}\n.navbar-expand-sm .offcanvas {\n  justify-content: center;\n}\n.green{\n  color:#68AD3F !important;\n}\n.grey-32{\n  color:#323232 !important;\n}\n.searchDiv {\n  margin-right: 7px;\n  margin-top: 12px;\n}\n.search,\n.search:focus {\n  border-width: 0px;\n  border-radius: 5px;\n  outline: 0;\n  -webkit-appearance: none;\n  box-shadow: none;\n  -moz-box-shadow: none;\n  -webkit-box-shadow: none;\n}\n::-webkit-input-placeholder {\n  color: #797979;\n}\n\n:-ms-input-placeholder {\n  color: #797979;\n}\n\n::placeholder {\n  color: #797979;\n}\n.web-btn {\n  min-width: 134px !important;\n}\n\n.MuiTabs-flexContainer {\n  justify-content: space-between;\n}\n\n.gridImage {\n  padding: 0 !important;\n}\n\n.gridImage {\n  object-fit: contain;\n  width: 100%;\n  height: 100%;\n}\n.home-page-tab .MuiTabs-indicator {\n  height: 3px;\n}\n#mui-p-41355-T-1 .MuiTabs-indicator {\n  background-color: #000000 !important;\n}\n#mui-p-43674-T-2 {\n}\n.gridImage1 {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n}\n\n.MuiTabs-root {\n  flex-grow: 1;\n}\n\n.MuiButtonBase-root-MuiButton-root:hover {\n  -webkit-text-decoration: none;\n  text-decoration: none;\n  background-color: initial;\n  border: 2px solid #68ad3f;\n}\n.MuiButtonBase-root-MuiButton-root {\n  line-height: normal !important;\n  padding: 10px !important;\n}\n.advantages-card p {\n  padding-top: 10px;\n}\n\n.font-20 {\n  padding: 50px 0px 50px 0px;\n  font-size: 20px;\n  color: #68ad3f;\n  text-align: center;\n}\n\n.border-btm {\n  border-bottom: 1px solid rgb(241, 241, 241);\n  z-index: -1;\n  position: absolute;\n  width: 100%;\n  left: 0px;\n}\n\n.bg-1 {\n  background-color: #f4ffee;\n  height: 300px;\n  width: 100%;\n  z-index: -1;\n  position: absolute;\n  left: 0px;\n  transform: skewY(-2deg);\n  margin: 40px 0px 40px 0px;\n}\n\n.bg-2 {\n  background-color: #fffaf2;\n  height: 300px;\n  width: 100%;\n  z-index: -2;\n  position: absolute;\n  left: 0px;\n  transform: skewY(2deg);\n  margin: 40px 0px 40px 0px;\n}\n\n.dashboard-Org {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #68ad3f;\n  height: 289px;\n  margin: 80px 0px 80px 0px;\n}\n\n.registration {\n  height: 393px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  line-height: 12px !important;\n}\n\n.searchbutton {\n  border: none;\n  background: white;\n  margin-left: -40px !important;\n  justify-content: center;\n}\n\n.desktop-heading {\n  display: block;\n  font-weight: 700;\n  color: #88d35b;\n}\n\n.heading-color {\n  color: #fbb040;\n}\n\n.mobile-heading {\n  display: none;\n}\n\n.border-line {\n  border-bottom: 1px solid rgb(241, 241, 241);\n  margin-top: 20px;\n  z-index: -1;\n  position: absolute;\n  width: 100%;\n  left: 0px;\n}\n\n.border-line-2 {\n  border-bottom: 1px solid rgb(241, 241, 241);\n  margin-top: 5px;\n  z-index: -1;\n  position: absolute;\n  width: 100%;\n  left: 0px;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.open-events {\n  height: 300px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  margin-bottom: 50px;\n}\n\n.advantages {\n  text-align: center;\n  line-height: 31.5px;\n  padding: 50px 0px 50px 0px;\n}\n\n.advantages-list {\n  display: flex;\n  justify-content: space-between;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 62px;\n}\n\n.adv-title {\n  color: #424242;\n  font-size: 24px;\n  line-height: 28.44px;\n  font-weight: 500;\n}\n\n.search {\n  width: \"219px\";\n  padding: 10px 10.51px 10px 10px;\n  margin-right: -4px;\n  outline: none;\n}\n\n.getPaidIcon {\n  width: 60px;\n  height: 60px;\n  background: #ececec;\n  border-radius: 50px;\n}\n\n.WhyFeis h2 {\n  font-family: \"Rubik\";\n  font-weight: 500;\n  font-size: 24px;\n  color: black;\n  margin: 120px 0 40px 0;\n}\n\n.WhyFeis {\n}\n\n.adv-desc {\n  font-family: \"Rubik\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  color: #424242;\n  opacity: 0.7;\n}\n\n.experience {\n  display: flex;\n  align-items: center;\n  padding: 50px 0px 50px 0px;\n}\n\n/* .kids-img {\n  height: 100%;\n  width: 500px;\n} */\n\n.exp-details {\n  margin-top: 20px;\n  font-size: 21px;\n  line-height: 32px;\n  text-align: left;\n  color: rgba(0, 0, 0, 0.702469);\n}\n\n.dashboard-organizer img {\n  width: 180.95px;\n  height: 62px;\n}\n\n.dashboard-organizer {\n  height: 318px;\n  position: relative;\n  font-family: \"Rubik\";\n  color: #68ad3f;\n  column-gap: 10px;\n}\n\n.dashboard-organizer h3 {\n  font-weight: 700;\n  font-size: 52px !important;\n}\n\n.bg-3 {\n  background-color: #f4ffee;\n  width: 100%;\n  z-index: -2;\n  position: absolute;\n  left: 0px;\n  transform: skewY(2deg);\n  height: 318px;\n}\n\n.background-slant {\n  height: 300px;\n  width: 100%;\n  z-index: -1;\n  position: absolute;\n  left: 0px;\n  background-color: #f4ffee;\n  transform: skewY(1deg);\n  margin: 40px 0px 40px 0px;\n}\n\n.event-links {\n  height: 819px;\n  display: flex;\n  align-items: center;\n}\n\n.event-links-title {\n  text-transform: uppercase;\n}\n\n.event-section-mobile {\n  display: none;\n}\n\n.event-section {\n  display: block;\n  z-index: -1;\n  position: absolute;\n  right: 0px;\n  width:40%;\n}\n\n.events-image {\n  width: 100%;\n}\n\n.links-section {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: 60px 0px 40px 0px;\n}\n\n.EventsList {\n  display: flex;\n  flex-wrap: wrap;\n  column-gap: 30px;\n  /* margin : 0px 20px; */\n}\n\n.EventsList1 {\n  display: flex;\n  column-gap: 30px;\n}\n\n.links-card {\n  display: flex;\n  align-items: center;\n  border: 1px solid #eaeaea;\n  border-radius: 10px;\n  height: 80px;\n  width: 273px;\n  margin: 20px;\n  padding: 10px;\n}\n\n.link-name {\n  margin: 0px 0px 0px 10px;\n}\n\n.orgaizerImg {\n  display: flex;\n  width: 77vw !important;\n  height: auto !important;\n\n  top: 0px;\n}\n\n.orgainzer-Content {\n  width: 796px;\n  font-family: \"Rubik\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 150%;\n  margin-top: 50px;\n\n  text-align: center;\n\n  color: #797979;\n}\n\n.orgainzer-Content span,\na {\n  color: #68ad3f !important;\n  text-decoration: none !important;\n}\n\n@media only screen and (min-width: 0px) and (max-width: 320px) {\n  .EventsList button {\n    font-size: 12px;\n    padding: 2px;\n    width: auto;\n  }\n}\n\n/*  <---------------------------- media query for mpbile devices ------------------------------------->  */\n@media only screen and (min-width: 0px) and (max-width: 767px) {\n  .EventsList-pd .MuiTabs-flexContainer .MuiTabs-flexContainer {\n    column-gap: 20px;\n  }\n  .dashboard-organizer {\n    height: 210px;\n  }\n  .mob-btn {\n    margin-top: -3rem !important;\n    margin-top: -3rem !important;\n  }\n  .event-links {\n    margin-bottom: -3rem !important;\n    margin-top: -3rem !important;\n  }\n  .cardSection .MuiTabPanel-root{\n    padding: 8px 24px;;\n  }\n  .css-ke65ae-MuiTabs-indicator {\n    position: absolute;\n    height: 2px;\n    bottom: 8px !important;\n    -webkit-transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    background-color: #68ad3f;\n  }\n  .orgainzer-Content {\n    width: 796px;\n    font-family: \"Rubik\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 150%;\n    margin-top: 5px;\n    text-align: center;\n    color: #797979;\n  }\n  .home-page-tab .MuiTabs-flexContainer .MuiButtonBase-root {\n    flex-grow: 1;\n    display: \"flex\";\n    margin-bottom: -9px;\n    min-width: 10px !important;\n    padding: 12px 0px !;\n    font-size: 12px;\n    min-height: 56px !important;\n  }\n  .home-page-tab .MuiTabs-flexContainer {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    padding-inline: 20px;\n    display: flex;\n    padding-inline: 20px;\n  }\n  .desktop-content {\n    font-family: \"Rubik\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 23px !important;\n    line-height: 0px;\n    text-align: center;\n    text-transform: uppercase;\n    color: #424242;\n  }\n\n  .WhyFeis h2 {\n    margin: 40px 0 40px 0;\n  }\n\n  .dashboard-organizer h3 {\n    font-size: 17px !important;\n  }\n\n  .dashboard-organizer img {\n    width: 81.95px;\n    height: 62px;\n  }\n\n  .font-20 {\n    padding: 20px 0px 50px 0px;\n  }\n\n  .advantages-list {\n    padding: 0px;\n  }\n\n  .search,\n  .search:focus {\n    width: 76.3vw;\n    height: 35px;\n\n    border-width: 0px;\n    outline: 0;\n    -webkit-appearance: none;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n  }\n\n  .searchbutton {\n    margin-top: 15px;\n  }\n\n  .EventsList {\n    margin: 0px 20px;\n  }\n\n  .EventsList1 {\n    flex-wrap: wrap;\n  }\n\n  .login-btn {\n    font-size: 10px !important;\n    width: 100% !important;\n    height: auto !important;\n  }\n\n  #regBtn {\n    cursor: pointer;\n    font-size: 0.875rem !important;\n    color: white !important;\n  }\n\n  .EventsList button {\n    font-size: 12px;\n    padding: 2px;\n    width: auto;\n  }\n\n\n  .border-btm {\n    display: none;\n  }\n\n  .mobile-heading {\n    font-weight: 700;\n    display: block;\n    color: #68ad3f;\n  }\n\n  .desktop-heading {\n    display: none;\n  }\n\n  .registration {\n    height: 300px;\n  }\n\n  .open-events {\n    height: 100%;\n    margin-bottom: 20px;\n  }\n\n  .bg-1 {\n    height: 200px;\n  }\n\n  .bg-2 {\n    height: 200px;\n  }\n\n  .bg-3 {\n    height: 200px;\n  }\n\n  .bg .register-events {\n    padding: 20px 0px 20px 0px;\n    align-items: flex-start;\n    flex-direction: column;\n    height: 100%;\n  }\n\n  .event-name {\n    font-size: 14px;\n  }\n  .reg-datee {\n    font-size: 11px;\n  }\n\n  .border-line {\n    display: none;\n  }\n\n  .web-btn {\n    display: none !important;\n  }\n\n  .advantages {\n    padding: 30px 20px 30px 20px;\n  }\n\n  .advantages-list {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .advantages-card {\n    padding: 10px 20px 10px 20px;\n  }\n\n  .exp-section {\n    text-align: center;\n    padding: 10px 0px 20px 0px;\n  }\n\n  .exp-details {\n    text-align: center;\n    padding: 20px 0px 0px 0px;\n  }\n\n  .experience {\n    flex-direction: column-reverse;\n    padding: 60px 20px 60px 20px;\n  }\n\n  /* .kids-img {\n    width: 100%;\n    padding: 20px 0px 0px 0px;\n  } */\n\n  .event-section-mobile {\n    display: block;\n  }\n\n  .background-slant {\n    height: 250px;\n  }\n\n  .organizer {\n    height: 200px;\n  }\n\n  .event-section {\n    display: none;\n  }\n\n  .create-event {\n    font-family: \"Rubik\";\n    font-style: normal;\n    font-weight: 500;\n    font-size: 40px;\n    line-height: 120%;\n    text-transform: uppercase;\n    color: #000000;\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n  }\n\n  .event-links {\n    height: 100%;\n    flex-direction: column;\n    padding: 80px 0px 30px 0px;\n  }\n\n  .events-image-mobile {\n    width: 100%;\n    padding: 20px 0px 20px 0px;\n  }\n\n  .why-feis {\n    height: 100%;\n  }\n\n  .border-line-2 {\n    display: none;\n  }\n\n  .mobile-btn {\n    background-color: #68ad3f;\n    color: white;\n  }\n\n  .links-card {\n    justify-content: flex-start;\n    padding: 15px;\n  }\n\n  .link-name {\n    margin-left: 10px;\n  }\n\n  .link {\n    margin-top: 4px;\n  }\n}\n\n.MuiButtonBase-root-MuiButton-root {\n  flex: none;\n}\n\n.organizer-content {\n  font-family: \"Rubik\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 52px;\n  line-height: 120%;\n  text-align: center;\n  text-transform: uppercase;\n  color: #68ad3f;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n@media only screen and (min-width: 481px) and (max-width: 600px) {\n  .heading-color {\n    font-size: 30px !important;\n  }\n\n  .mobile-heading {\n    font-size: 30px !important;\n  }\n\n  .desktop-content {\n    font-size: 25px !important;\n  }\n}\n@media screen and (max-width: 800px) {\n  .header.navbar-expand-sm .offcanvas {\n    position: relative;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    transition: none;\n  }\n  .offcanvas-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n    display: none !important;\n  }\n}\n/* / <---------------------------- media query for ipad devices -------------------------------------> / */\n@media only screen and (min-width: 760px) and (max-width: 980px) {\n  /* .kids-img {\n    width: 300px;\n  } */\n  .OrgImage {\n    padding: 2rem;\n  }\n\n  .advantages-list {\n    padding: 0px;\n    margin-top: 80px;\n  }\n  .dashboard-organizer h3 {\n    font-weight: 700;\n    font-size: 33px !important;\n  }\n  .dashboard-organizer img {\n    width: 120px;\n  }\n  .devincornell {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n\n  .event-section {\n    width: 50%;\n  }\n\n  .event-links {\n    height: 556px;\n  }\n\n  .event-links h2 {\n    font-size: 30px !important;\n  }\n\n  .dashboard-organizer {\n    align-items: center;\n  }\n  .desktop-content {\n    font-family: \"Rubik\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 40px !important;\n    line-height: 0px;\n    text-align: center;\n    text-transform: uppercase;\n    color: #424242;\n  }\n\n  #EventsList2 button {\n    font-size: 15px !important;\n  }\n\n  .gridImagerow {\n    margin-top: 50px;\n  }\n\n  .EventsList {\n    margin-top: -76px;\n  }\n  .home-page-tab .MuiTabs-flexContainer .MuiButtonBase-root {\n    min-height: 55px !important;\n    flex-grow: 1;\n    display: flex;\n    margin-bottom: -8px;\n    min-width: 10px !important;\n    padding: 12px 0px !;\n    font-size: 12px;\n  }\n}\n\n/*  <---------------------------- media query for ipad pro devices ------------------------------------->  */\n@media only screen and (min-width: 981px) and (max-width: 1210px) {\n  /* .kids-img {\n    width: 400px;\n  } */\n  .OrgImage {\n    padding: 2rem;\n    margin-top: \"110px\";\n  }\n  .dashboard-organizer {\n    align-items: center;\n  }\n  .event-links {\n    margin-left: 0vw !important;\n  }\n\n  [type=\"button\"]:not(:disabled), [type=\"reset\"]:not(:disabled), [type=\"submit\"]:not(:disabled), button:not(:disabled) {\n    cursor: pointer;\n  }\n  .desktop-content {\n    font-family: \"Rubik\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 40px !important;\n    line-height: 0px;\n    text-align: center;\n    text-transform: uppercase;\n    color: #424242;\n  }\n}\n@media screen and (min-width: 1200px) {\n  .eventListw {\n    width: 65vw;\n  }\n  .MuiTabs-indicator {\n    position: absolute;\n    height: 2px;\n    width: 100%;\n    -webkit-transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    background-color: #68ad3f;\n  }\n}\n\n@media only screen and (min-width: 1200px) and (max-width: 1900px) {\n  .OrgImage {\n    padding: 3rem;\n    margin-top: \"110px\";\n  }\n  .EventsList2 {\n    padding: 0px 0px 4rem 0px !important;\n  }\n\n  .orgainzer-Content {\n    width: auto;\n    font-family: \"Rubik\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 150%;\n    margin-top: -17px;\n    text-align: center;\n    color: #797979;\n    margin-bottom: 36px;\n  }\n  .desktop-content {\n    font-family: \"Rubik\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 40px !important;\n    text-align: center;\n    text-transform: uppercase;\n    color: #424242;\n  }\n  .dashboard-organizer {\n    align-items: center;\n    margin-bottom: 6rem;\n  }\n}\n\n@media only screen and (min-width: 1900px) and (max-width: 1930px) {\n  .devincornell {\n    padding: 50px 0px 0px 0px !important;\n  }\n\n  .dashboard-organizer {\n    align-items: center;\n    margin-bottom: 6rem;\n  }\n  .EventsList2 {\n    padding: 0px 0px 4rem 0px !important;\n  }\n  .OrgImage {\n    padding: 4.5rem;\n  }\n  .desktop-content {\n    font-family: \"Rubik\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 40px !important;\n    text-align: center;\n    text-transform: uppercase;\n    color: #424242;\n  }\n\n  .organizer {\n    margin-bottom: 6rem;\n  }\n  .title-signup {\n    height: 65px;\n    width: 165px;\n  }\n  .title-signup :hover {\n    border: 2px solid #68ad3f;\n  }\n  .create-event-btn {\n    padding: 13px !important;\n    border: 3px solid #68ad3f !important;\n  }\n  .MuiTypography-root {\n    margin: 0 !important;\n    font-family: Rubik !important;\n    font-weight: 400 !important;\n    font-size: 1rem !important;\n    line-height: 1.5 !important;\n    margin-bottom: 0.35em !important;\n    margin-bottom: 25px !important;\n    max-width: 100% !important;\n  }\n\n  .orgainzer-Content {\n    width: 100% !important;\n    font-family: \"Rubik\" !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n    font-size: 20px !important;\n    line-height: 150% !important;\n    margin-top: 50px !important;\n    text-align: center !important;\n    color: #797979 !important;\n  }\n\n  .WhyFeis h2 {\n    font-family: \"Rubik\" !important;\n    font-weight: 500 !important;\n    color: black !important;\n  }\n\n  .event-section {\n    display: flex;\n    z-index: -1;\n    position: absolute;\n    right: 0px;\n  }\n\n  .event-section {\n    position: relative;\n    display: none;\n  }\n\n  .event-section-mobile {\n    display: contents;\n  }\n\n  .events-image-mobile {\n    height: 67%;\n    position: absolute;\n    float: right;\n    right: 0%;\n  }\n\n  .event-links {\n    height: 563px;\n    display: flex;\n    align-items: center;\n  }\n\n  .adv-desc {\n    font-family: \"Rubik\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 17px;\n    color: #424242;\n    opacity: 0.7;\n  }\n\n  .advantages-list {\n    display: flex;\n    justify-content: space-between;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 0px;\n  }\n\n  .css-112coge {\n    max-width: 100% !important;\n  }\n\n  .adv-title {\n    color: #424242 !important;\n  }\n  .search, .search:focus {\n    border-width: 0px;\n    border-radius: 5px;\n    outline: 0;\n    -webkit-appearance: none;\n    box-shadow: none;\n    -moz-box-shadow: none;\n    -webkit-box-shadow: none;\n  }\n\n  .MuiTabs-flexContainer {\n    justify-content: space-between;\n  }\n\n  .imageGridContainer {\n    margin-bottom: 100px;\n  }\n\n  .endGrid {\n    padding: 0 !important;\n  }\n\n  .gridImage {\n    padding: 0 !important;\n  }\n\n  .gridImage {\n    object-fit: contain;\n    width: 100%;\n    height: 100%;\n  }\n\n  .gridImage1 {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n  }\n\n  .MuiTabs-root {\n    flex-grow: 1;\n  }\n\n  .MuiButtonBase-root-MuiButton-root:hover {\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    background-color: initial;\n    border: 2px solid #68ad3f;\n  }\n  .MuiButtonBase-root-MuiButton-root {\n    line-height: normal !important;\n    padding: 10px !important;\n  }\n  .advantages-card p {\n    padding-top: 10px;\n  }\n\n  .font-20 {\n    padding: 50px 0px 50px 0px;\n    font-size: 20px;\n    color: #68ad3f;\n    text-align: center;\n  }\n\n  .border-btm {\n    border-bottom: 1px solid rgb(241, 241, 241);\n    z-index: -1;\n    position: absolute;\n    width: 100%;\n    left: 0px;\n  }\n\n  .bg-1 {\n    background-color: #f4ffee;\n    height: 300px;\n    width: 100%;\n    z-index: -1;\n    position: absolute;\n    left: 0px;\n    transform: skewY(-2deg);\n    margin: 40px 0px 40px 0px;\n  }\n\n  .bg-2 {\n    background-color: #fffaf2;\n    height: 300px;\n    width: 100%;\n    z-index: -2;\n    position: absolute;\n    left: 0px;\n    transform: skewY(2deg);\n    margin: 40px 0px 40px 0px;\n  }\n\n  .dashboard-Org {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #68ad3f;\n    height: 289px;\n    margin: 80px 0px 80px 0px;\n  }\n\n  .registration {\n    height: 380px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  .searchbutton {\n    border: none;\n    background: white;\n    margin-left: -40px !important;\n    justify-content: center;\n  }\n\n  .desktop-content {\n    font-family: \"Rubik\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 40px;\n    text-align: center;\n    text-transform: uppercase;\n  }\n\n  .desktop-heading {\n    display: block;\n    font-weight: 700;\n    color: #88d35b;\n    font-size: 60px !important;\n  }\n\n  .heading-color {\n    color: #fbb040;\n  }\n\n  .mobile-heading {\n    display: none;\n  }\n\n  .border-line {\n    border-bottom: 1px solid rgb(241, 241, 241);\n    margin-top: 20px;\n    z-index: -1;\n    position: absolute;\n    width: 100%;\n    left: 0px;\n  }\n\n  .border-line-2 {\n    border-bottom: 1px solid rgb(241, 241, 241);\n    margin-top: 5px;\n    z-index: -1;\n    position: absolute;\n    width: 100%;\n    left: 0px;\n  }\n\n  .text-center {\n    text-align: center;\n  }\n\n  .open-events {\n    height: 300px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    margin-bottom: 50px;\n  }\n\n  .advantages {\n    text-align: center;\n    line-height: 31.5px;\n    padding: 50px 0px 50px 0px;\n  }\n\n  .advantages-list {\n    display: flex;\n    justify-content: space-between;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 62px;\n  }\n\n  .adv-title {\n    color: #424242;\n    font-size: 24px;\n    line-height: 28.44px;\n    font-weight: 500;\n  }\n\n  .search {\n    width: \"219px\";\n    padding: 8px 10px;\n    margin-right: -4px;\n    outline: none;\n  }\n\n  .getPaidIcon {\n    width: 60px;\n    height: 60px;\n    background: #ececec;\n    border-radius: 50px;\n  }\n\n  .WhyFeis h2 {\n    font-family: \"Rubik\";\n    font-weight: 500;\n    font-size: 24px;\n    color: black;\n    margin: 120px 0 40px 0;\n  }\n\n  .adv-desc {\n    font-family: \"Rubik\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    color: #424242;\n    opacity: 0.7;\n  }\n\n  .experience {\n    display: flex;\n    align-items: center;\n    padding: 50px 0px 50px 0px;\n  }\n\n  /* .kids-img {\n    height: 100%;\n    width: 500px;\n  } */\n\n  .exp-details {\n    margin-top: 20px;\n    font-size: 21px;\n    line-height: 32px;\n    text-align: left;\n    color: rgba(0, 0, 0, 0.702469);\n  }\n\n  .dashboard-organizer img {\n    width: 180.95px;\n    height: 62px;\n  }\n\n  .dashboard-organizer {\n    height: 318px;\n    position: relative;\n    font-family: \"Rubik\";\n    color: #68ad3f;\n    column-gap: 10px;\n  }\n\n  .dashboard-organizer h3 {\n    font-weight: 700;\n    font-size: 52px !important;\n  }\n\n  .bg-3 {\n    background-color: #f4ffee;\n    width: 100%;\n    z-index: -2;\n    position: absolute;\n    left: 0px;\n    transform: skewY(2deg);\n    height: 318px;\n  }\n\n  .background-slant {\n    height: 300px;\n    width: 100%;\n    z-index: -1;\n    position: absolute;\n    left: 0px;\n    background-color: #f4ffee;\n    transform: skewY(1deg);\n    margin: 40px 0px 40px 0px;\n  }\n\n  .event-links {\n    height: 819px;\n    display: flex;\n    align-items: center;\n  }\n\n  .event-links-title {\n    text-transform: uppercase;\n  }\n\n  .event-section-mobile {\n    display: none;\n  }\n\n  .event-section {\n    display: block;\n    z-index: -1;\n    position: absolute;\n    right: 0px;\n  }\n\n  .events-image {\n    width: 100%;\n  }\n\n  .links-section {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    margin: 60px 0px 40px 0px;\n  }\n\n  .EventsList {\n    display: flex;\n    flex-wrap: wrap;\n    column-gap: 30px;\n    margin: 0px 20px;\n  }\n  .eventListw {\n    width: 51vw;\n  }\n\n  .EventsList1 {\n    display: flex;\n    column-gap: 30px;\n  }\n\n  .links-card {\n    display: flex;\n    align-items: center;\n    border: 1px solid #eaeaea;\n    border-radius: 10px;\n    height: 80px;\n    width: 273px;\n    margin: 20px;\n    padding: 10px;\n  }\n\n  .link-name {\n    margin: 0px 0px 0px 10px;\n  }\n\n  .orgaizerImg {\n    display: flex;\n    width: 77vw !important;\n    height: auto !important;\n    top: 0px;\n  }\n\n  .orgainzer-Content {\n    width: 796px;\n    font-family: \"Rubik\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 150%;\n    margin-top: 50px;\n    text-align: center;\n    color: #797979;\n  }\n\n  .orgainzer-Content span,a {\n    color: #68ad3f !important;\n    text-decoration: none !important;\n  }\n  /* / <---------------------------- media query for mpbile devices -------------------------------------> / */\n  @media only screen and (min-width: 0px) and (max-width: 900px) {\n    .dashboard-organizer {\n      height: 210px;\n    }\n    .home-page-tab {\n      display: flex;\n      flex-grow: 1;\n      margin-bottom: 9px;\n    }\n    .desktop-content {\n      font-family: \"Rubik\";\n      font-style: normal;\n      font-weight: 400;\n      font-size: 25px !important;\n      text-align: center;\n      text-transform: uppercase;\n      color: #424242;\n    }\n\n    .WhyFeis h2 {\n      margin: 40px 0 40px 0;\n    }\n\n    .dashboard-organizer h3 {\n      font-size: 17px !important;\n      margin-top: 10px;\n    }\n\n    .dashboard-organizer img {\n      width: 81.95px;\n      height: 62px;\n    }\n\n    .font-20 {\n      padding: 20px 0px 50px 0px;\n    }\n\n    .advantages-list {\n      padding: 0px;\n    }\n\n    .search, .search:focus {\n      width: 76.3vw;\n      height: 35px;\n      border-width: 0px;\n      outline: 0;\n      -webkit-appearance: none;\n      box-shadow: none;\n      -moz-box-shadow: none;\n      -webkit-box-shadow: none;\n    }\n\n    .searchbutton {\n      margin-top: 15px;\n    }\n\n    .EventsList {\n      margin: 0px 20px;\n    }\n\n    .EventsList1 {\n      flex-wrap: wrap;\n    }\n\n    [type=\"button\"]:not(:disabled),\n    [type=\"reset\"]:not(:disabled),\n    [type=\"submit\"]:not(:disabled),\n    button:not(:disabled) {\n      font-size: 14px;\n      width: auto;\n      height: auto;\n    }\n\n    .login-btn {\n      font-size: 10px !important;\n      width: 100% !important;\n      height: auto !important;\n    }\n\n    #regBtn {\n      cursor: pointer;\n      font-size: 14px !important;\n      color: white !important;\n    }\n\n    .EventsList button {\n      font-size: 16px;\n      padding: 2px;\n    }\n\n    .border-btm {\n      display: none;\n    }\n\n    .mobile-heading {\n      font-weight: 700;\n      display: block;\n      color: #68ad3f;\n    }\n\n    .desktop-heading {\n      display: none;\n    }\n\n    .registration {\n      height: 300px;\n    }\n\n    .open-events {\n      height: 100%;\n      margin-bottom: 20px;\n    }\n\n    .bg-1 {\n      height: 200px;\n    }\n\n    .bg-2 {\n      height: 200px;\n    }\n\n    .bg-3 {\n      height: 200px;\n    }\n\n    .bg .register-events {\n      padding: 20px 0px 20px 0px;\n      align-items: flex-start;\n      flex-direction: column;\n      height: 100%;\n    }\n\n    .event-name {\n      font-size: 12px;\n    }\n\n    .border-line {\n      display: none;\n    }\n\n    .web-btn {\n      display: none !important;\n    }\n\n    .advantages {\n      padding: 30px 20px 30px 20px;\n    }\n\n    .advantages-list {\n      display: flex;\n      flex-direction: column;\n    }\n\n    .advantages-card {\n      padding: 10px 20px 10px 20px;\n    }\n\n    .exp-section {\n      text-align: center;\n      padding: 10px 0px 20px 0px;\n    }\n\n    .exp-details {\n      text-align: center;\n      padding: 20px 0px 0px 0px;\n    }\n\n    .experience {\n      flex-direction: column-reverse;\n      padding: 60px 20px 60px 20px;\n    }\n\n    /* .kids-img {\n      width: 100%;\n      padding: 20px 0px 0px 0px;\n    } */\n\n    .event-section-mobile {\n      display: block;\n    }\n\n    .background-slant {\n      height: 250px;\n    }\n\n    .organizer {\n      height: 200px;\n    }\n\n    .event-section {\n      display: none;\n    }\n\n    .create-event {\n      font-family: \"Rubik\";\n      font-style: normal;\n      font-weight: 500;\n      font-size: 40px;\n      line-height: 120%;\n      text-transform: uppercase;\n      color: #000000;\n      flex: none;\n      order: 0;\n      flex-grow: 0;\n    }\n\n    .event-links {\n      height: 100%;\n      flex-direction: column;\n      padding: 80px 0px 30px 0px;\n    }\n\n    .events-image-mobile {\n      width: 100%;\n      padding: 20px 0px 20px 0px;\n    }\n\n    .why-feis {\n      height: 100%;\n    }\n\n    .border-line-2 {\n      display: none;\n    }\n\n    .mobile-btn {\n      background-color: #68ad3f;\n      color: white;\n    }\n\n    .links-card {\n      justify-content: flex-start;\n      padding: 15px;\n    }\n\n    .link-name {\n      margin-left: 10px;\n    }\n\n    .link {\n      margin-top: 4px;\n    }\n  }\n\n  .MuiButtonBase-root-MuiButton-root {\n    flex: none;\n  }\n\n  .organizer-content {\n    font-family: \"Rubik\";\n    font-style: normal;\n    font-weight: 700;\n    font-size: 52px;\n    line-height: 120%;\n    text-align: center;\n    text-transform: uppercase;\n    color: #68ad3f;\n    flex: none;\n    order: 1;\n    flex-grow: 0;\n  }\n\n  @media only screen and (min-width: 481px) and (max-width: 600px) {\n    .heading-color {\n      font-size: 30px !important;\n    }\n\n    .mobile-heading {\n      font-size: 30px !important;\n    }\n\n    .desktop-content {\n      font-size: 25px !important;\n    }\n  }\n\n \n  /* / <---------------------------- media query for ipad devices -------------------------------------> / */\n  @media only screen and (min-width: 760px) and (max-width: 980px) {\n    /* .kids-img {\n      width: 300px;\n    } */\n\n    .advantages-list {\n      padding: 0px;\n      margin-top: 80px;\n    }\n\n    .event-section {\n      width: 50%;\n    }\n\n    .event-links {\n      height: 556px;\n    }\n\n    .event-links h2 {\n      font-size: 30px !important;\n    }\n    .MuiTabs-indicator {\n      position: absolute;\n      height: 2px;\n      bottom: 8px !important;\n      width: 100%;\n      -webkit-transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n      transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n      background-color: #68ad3f;\n    }\n\n    .dashboard-organizer {\n      align-items: center;\n    }\n\n    [type=\"button\"]:not(:disabled),\n    [type=\"reset\"]:not(:disabled),\n    [type=\"submit\"]:not(:disabled),\n    button:not(:disabled) {\n      cursor: pointer;\n      font-size: 14px !important;\n    }\n\n    #EventsList2 button {\n      font-size: 15px !important;\n    }\n\n    .gridImagerow {\n      margin-top: 50px;\n    }\n\n    .EventsList {\n      margin-top: 50px;\n    }\n  }\n\n  /* / <---------------------------- media query for ipad pro devices -------------------------------------> / */\n  @media only screen and (min-width: 981px) and (max-width: 1210px) {\n    /* .kids-img {\n      width: 400px;\n    } */\n    .OrgImage {\n      padding: 2rem;\n    }\n    .dashboard-organizer {\n      align-items: center;\n    }\n\n    .event-links {\n      margin-left: 0vw !important;\n    }\n\n    [type=\"button\"]:not(:disabled),\n    [type=\"reset\"]:not(:disabled),\n    [type=\"submit\"]:not(:disabled),\n    button:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n\n  @media only screen and (min-width: 1200px) and (max-width: 1800px) {\n    .OrgImage {\n      padding: 2rem;\n    }\n    .desktop-content {\n      font-family: \"Rubik\";\n      font-style: normal;\n      font-weight: 400;\n      font-size: 40px !important;\n      text-align: center;\n      text-transform: uppercase;\n      color: #424242;\n    }\n  }\n\n  @media only screen and (min-width: 1900px) and (max-width: 1930px) {\n    .organizer {\n      margin-bottom: 6rem;\n    }\n\n    .MuiTypography-root {\n      margin: 0 !important;\n      font-family: Rubik !important;\n      font-weight: 400 !important;\n      font-size: 1rem !important;\n      line-height: 1.5 !important;\n      margin-bottom: 0.35em !important;\n      margin-bottom: 25px !important;\n      max-width: 100% !important;\n    }\n\n    .orgainzer-Content {\n      width: 90% !important;\n      font-family: \"Rubik\" !important;\n      font-style: normal !important;\n      font-weight: 400 !important;\n      font-size: 20px !important;\n      line-height: 150% !important;\n      margin-top: -48px !important;\n      margin-bottom: 35px;\n      text-align: center !important;\n      color: #797979 !important;\n    }\n\n    .WhyFeis h2 {\n      font-family: \"Rubik\" !important;\n      font-weight: 500 !important;\n      color: black !important;\n      font-size: 40px;\n      font-size: 40px !important;\n      padding: 25px;\n    }\n\n    .event-section {\n      display: flex;\n      z-index: -1;\n      position: absolute;\n      right: 0px;\n    }\n\n    .event-section {\n      position: relative;\n      display: none;\n    }\n\n    .event-section-mobile {\n      display: contents;\n    }\n\n    .events-image-mobile {\n      height: 67%;\n      position: absolute;\n      float: right;\n      right: 0%;\n    }\n\n    .event-links {\n      height: 563px;\n      display: flex;\n      align-items: center;\n    }\n\n    .adv-desc {\n      font-family: \"Rubik\";\n      font-style: normal;\n      font-weight: 400;\n      font-size: 17px;\n      color: #797979;\n      opacity: 0.7;\n    }\n\n    .advantages-list {\n      display: flex;\n      justify-content: space-between;\n      margin-left: auto;\n      margin-right: auto;\n      padding: 0px;\n    }\n\n    .css-112coge {\n      max-width: 100% !important;\n    }\n\n    .adv-title {\n      color: #424242 !important;\n      font-size: 30px !important;\n      line-height: 28.44px !important;\n      font-weight: 500 !important;\n    }\n    #EventsList2 {\n    }\n\n    .EventsList1 {\n      display: flex !important;\n      column-gap: 30px !important;\n    }\n  }\n}\n\n.EventsList1 {\n  display: flex !important;\n  column-gap: 30px !important;\n}\n\n@media only screen and (min-width: 787px) and (max-width: 2000px) {\n  .MuiTabPanel-root {\n    padding: 0px 0 !important;\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .create-event Button {\n    padding: 12px 32px 12px 32px !important;\n    margin-top: 48px !important;\n  }\n}\n@media screen and (min-width: 1800px) {\n  .create-event Button {\n    padding: 10px 24px 10px 24px !important;\n    margin-top: 48px !important;\n  }\n  .desktop-content {\n    font-size: 42px !important;\n  }\n}\n@media screen and (max-width: 480px) {\n  .offcanvas-body {\n    flex-grow: 1;\n    padding: 0px !important;\n    overflow-y: auto;\n  }\n  .header.navbar-expand-sm .offcanvas {\n    position: relative !important;\n  }\n  .navbar-expand-sm {\n    padding: 0px 8px !important;\n  }\n}\n@media screen and (max-width: 600px) {\n  .title-signup {\n    font-size: 16px !important;\n  }\n}\n\n@media screen and (min-width: 1900px) {\n  .desktop-content {\n    font-size: 42px !important;\n    margin-top: 38px !important;\n  }\n  .bg-1 {\n    background-color: #f4ffee;\n    height: 342px;\n    width: 100%;\n    z-index: -1;\n    position: absolute;\n    left: 0px;\n    transform: skewY(-2deg);\n    margin: 40px 0px 40px 0px;\n  }\n  .bg-2 {\n    background-color: #fffaf2;\n    height: 342px;\n    width: 100%;\n    z-index: -2;\n    position: absolute;\n    left: 0px;\n    transform: skewY(2deg);\n    margin: 40px 0px 40px 0px;\n  }\n  .cardSection {\n    padding: 70px 0px 0px 0px !important;\n  }\n  .OrgImage {\n    padding: 62px 0px 50px 0px;\n  }\n  .dashboard-organizer h3 {\n    font-weight: 700;\n    font-size: 60px !important;\n  }\n  .WhyFeis h2 {\n    padding: 0px 0px 25px 0px;\n}\n}\n\n@media screen and (max-width:700px) {\n  .registration {\n    height: 270px;\n}\n.create-event .MuiButtonBase-root{\nfont-size: 16px;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
